import { Component, ContentChild, EventEmitter, HostListener, Input, OnInit, Output,ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { ModeEffectif, Option, RenderType, SelectionMode } from '../../models/effectif/option.model';
import { CoreService, HttpService, UtilitiesService } from '../../services';
import { EffectifsService } from '../effectifs.service';
import { CRUD, GridParamGeneric, QueovalDik, Select } from '../../models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericEffectif } from '../../models/effectif/genericEffectif.model';
import { StageService } from '../../formation/stage-modal/stage-onglet/services/stage-modal.service';
import { ColDef, Column, ColumnApi, GridApi, RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { EffectifModel } from '../../models/effectif/effectif.model';
import { InfoLienEffectifs } from '../../models/effectif/infoLienEffectifs.model';
import { ToastService } from '../../toast';

import { CustomGridService } from '../../customgrid';
import { Subscription, Subject } from 'rxjs';
import { SpecificColumnEffectif } from '../../models/effectif/effectif-utilities.model';
import { DocxPreselect } from '../../models/document/model.docx.preselect';
import { forEach, isNull } from 'lodash';



@Component({
  providers: [EffectifsService],
  selector: 'q-effectifs',
  templateUrl: './effectifs-wrapper.component.html',  
  styleUrls: ['./effectifs-wrapper.component.css']
})
export class EffectifsWrapperComponent implements OnInit {

  constructor(
    protected http: HttpService,
    public service: EffectifsService,
    public indParam: CoreService,
    protected modalService: NgbModal,
    private customgridservice: CustomGridService,
    public stageService: StageService,
    public utilities: UtilitiesService,
    private toast: ToastService,
  ) { }

  @Input('Option') set setOption(value: Option) {
    this.service.Options = value;
  }

  @Input('RefreshEffectif') set setRefresh(value: boolean) {
    if (value) {
      this.indeterminate = false;
      this.AllAreSelected = false;
      this.service.loadData();
    }
  }

  @Input('NeedInfoExtranet') set SetNeedInfoExtranet(value: boolean) {
    this.service.EffectifModel.NeedInfoExtranet = value;
  }

  @Input('ListEffectifChecked') set SetListEffectifChecked(value: Array<string>) {

    this.service.ListIdChecked = value;
  }

  @Input('docxpreselect$') docxpreselect$: Subject<DocxPreselect>;
  private subscription: Subscription;

  @Input() show: boolean = true;
  @Output('EffectifToEmit') effectifEmitter: EventEmitter<Array<GenericEffectif>> = new EventEmitter<Array<GenericEffectif>>();


  @ContentChild(TemplateRef) layoutTemplate: TemplateRef<any>;

  RenderType = RenderType;

  SelectionMode = SelectionMode;

  CRUD = CRUD;

  public AllAreSelected: boolean = false;

  public indeterminate: boolean = false;

  public ShowManagerPopOver: boolean = false;

  public screenSize: number;

  private selectedNodes: RowNode[];

  private gridAPI: GridApi;

  private subscript: Subscription;



  // sert pour gérer la popover manager en fonction du resize
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenSize = window.innerWidth;
  }

  /** Fermeture automatique des menus
 * 
 * @param event
 */
  @HostListener('document:click', ['$event'])
  close(event: any) {
    if (event.currentTarget.activeElement.id != this.service.Options.Title) {
      this.ShowManagerPopOver = false;
    }
  }


  ngOnDestroy(): void {
    if (this.subscription != null)
      this.subscription.unsubscribe();
  }


  ngOnInit(): void {
    this.screenSize = window.innerWidth;

    //On affecte le model effectif avec les différentes options et modes avant de l'envoyer au back 
    this.service.setOption();

    //on récup les infos en envoyant le model effectifs
    this.service.loadData();
  }


  public ngAfterViewInit(): void {
    if (this.docxpreselect$ != null) {
      this.subscription = this.docxpreselect$.subscribe(valeur => {
        switch (this.service.Options.Mode) {
          case ModeEffectif.CLIENTMAIL:
            this.OnForceAll(valeur.Ckclient == "1");
            break;
          case ModeEffectif.STAGIAIREMAIL:
            this.OnForceAll(valeur.Ckstagiaire == "1");
            break;
        }
      });
    }
  }

  public showManager(event: Event) {
    event.stopPropagation();   
    this.ShowManagerPopOver =! this.ShowManagerPopOver;
  }


  /** Empecher la fermeture à n'importe quel clique
   * 
   * @param event
   */
  stopPropagation(event: Event) {
    event.stopPropagation();
  }


  // méthode qui agi après séléction d'un client dans le filtre
  public selectFilter(value: string) {
    if (value != "NONE") {

      this.service.EffectifModel.AllData.IdOrigin = value;
    } else {
      this.service.EffectifModel.AllData.IdOrigin = '';
    }
    this.service.loadData();
  }

  public OnSelectAll() {

    const addAll: boolean = this.service.SelectedSelect.length == 0;
    if (addAll) {
      this.service.SelectedSelect = this.service.EffectifModel.DataListSelect.map(effectif => { effectif.IsSelected = true; return effectif; });
    } else {
      this.service.SelectedSelect = this.service.EffectifModel.DataListSelect.map(effectif => { effectif.IsSelected = false; return effectif; });
    }

    this.effectifEmitter.emit((this.service.SelectedSelect));

    if ((this.service.SelectedSelect.filter(effectif => !effectif.IsSelected).length) == this.service.SelectedSelect.length) {
      this.service.SelectedSelect = new Array<GenericEffectif>();
    }

    this.indeterminate = false;

    //Long story short checkbox are broken
    setTimeout(() => {
      this.AllAreSelected = addAll;
    }, 0);
  }


  public OnForceAll(addAll: boolean) {
    //delais pour laisser le temps aux composant detre visible
    setTimeout(() => {
      if (this.service.EffectifModel.DataListSelect != null && this.service.EffectifModel.DataListSelect !== undefined) {
        this.service.EffectifModel.DataListSelect.forEach((node: GenericEffectif) => node.IsSelected = addAll);
        if (addAll) {
          this.service.SelectedSelect = this.service.EffectifModel.DataListSelect;
        } else {

          this.service.SelectedSelect = new Array<GenericEffectif>();
        }
        this.effectifEmitter.emit((this.service.SelectedSelect));
        this.indeterminate = false;

        //Long story short checkbox are broken
        setTimeout(() => {
          this.AllAreSelected = addAll;
        }, 0);
      }      
    }, 200);

  }


  public SingleEmit(receivedData: GenericEffectif) {
    if (this.service.Options.SelectionMode == SelectionMode.MULTIPLE) {
      this.service.SelectedSelect = this.service.EffectifModel.DataListSelect.map(effectif => {
        if (effectif.Id == receivedData.Id) {
          effectif.IsSelected = receivedData.IsSelected;
        }
        return effectif;

      });
    } else if (this.service.Options.SelectionMode == SelectionMode.SINGLE) {
      this.service.SelectedSelect = this.service.EffectifModel.DataListSelect.filter(effectif => effectif.IsSelected);
    } else {
      this.service.SelectedSelect = this.service.EffectifModel.DataListSelect.filter(effectif => effectif.Id == receivedData.Id);
    }



    this.effectifEmitter.emit(this.service.SelectedSelect);

    this.indeterminate = this.service.SelectedSelect.length > 0 && (this.service.SelectedSelect.filter(eff => eff.IsSelected).length > 0 && this.service.SelectedSelect.filter(eff => !eff.IsSelected).length > 0);
    if (!this.indeterminate) {
      this.AllAreSelected = this.service.SelectedSelect.length == this.service.EffectifModel.DataListSelect?.length && !(this.service.SelectedSelect.filter(eff => !eff.IsSelected).length > 0);
    }
  }

  public selectLine(event: SelectionChangedEvent) {

    this.gridAPI = event.api;

    let rowData: Array<RowNode> = [];
    this.gridAPI.forEachNode(node => rowData.push(node));
    this.selectedNodes = rowData;
  }

  // Ouverture de la modal
  public OpenCG(Modal: any) {
    if (!this.utilities.isEmptyStr(this.service.EffectifModel.GridFileName)) {

      this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' });

      this.http.getHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/getData/GET_COLUMN/0`).subscribe((data: EffectifModel) => {
        this.service.EffectifModel.LstColumnToSave = data.LstColumnToSave;
      })
    }
  }

  public closeModal() {
    //this.subscript.unsubscribe();
    this.modalService.dismissAll();
  }

  // Méthode déclenché a la modif d'une cell de l'ag grid
  public saveInfoLienCG(e: any) {
    let effectifModel: EffectifModel = new EffectifModel();
    effectifModel.InfoLiens = new Array<InfoLienEffectifs>();
    let lienEffectif: InfoLienEffectifs = new InfoLienEffectifs();
    lienEffectif.ListeValue = new Array<QueovalDik>();
    lienEffectif.IdRelation = this.service.EffectifModel.SelectedData.Relation;
    lienEffectif.IdFils = this.service.EffectifModel.SelectedData.IdOrigin;
    lienEffectif.IdPere = e.node.data.Ident;
    effectifModel.Mode = "SAVE_INFO_LIEN_CG";

    const colName = e.colDef.field;
    let value = e.value;

    lienEffectif.ListeValue.push(new QueovalDik(colName, value));
    effectifModel.InfoLiens.push(lienEffectif);

    this.http.postHttp<EffectifModel>(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, effectifModel).subscribe((data: EffectifModel) => {
      if (!data.HasError) {
        //// Fermeture de la popup
        //this.closeModal();
        this.toast.showSuccessToast("Enregistrement effectué");
      }
    });
  }
}
